export default "__VITE_ASSET__3f11cda2__"